import { datalakeToken } from '../app/pages/datalake/token-prod';

export const environment = {
  production: true,

  appUrl: 'argos.mg.gov.br',
  apiUrl: 'https://argos.mg.gov.br/*',
  service: 'https://backend.argos.mg.gov.br/api/v1',
  authService: 'https://backend.argos.mg.gov.br/api',

  datalake: {
    datalakeService: 'https://apigw.mgapi.prodemge.gov.br/cloudera/dlage/1.0.0',
    token: datalakeToken
  }
};

console.log = function(): void {};